module.exports = __webpack_public_path__ + "static/seo-mycurrency-f9b7e12835765f1d558ed1a4c64350b1.png";